export interface DestinationForm {
  estimatedLoanAmount: string;
  loanAmountCurrency: string;
  expectedArrivalDate: string;
  expectedGraduationDate: string;
}

// We need to extract to a reference data hook
export const SUPPORTED_LOAN_CURRENCIES_OPTIONS = [
  {
    label: 'USD',
    value: 'USD',
  },
  {
    label: 'CAD',
    value: 'CAD',
  },
  {
    label: 'EUR',
    value: 'EUR',
  },
  {
    label: 'GBP',
    value: 'GBP',
  },
  {
    label: 'AUD',
    value: 'AUD',
  },
  {
    label: 'INR',
    value: 'INR',
  },
];
